// eslint-disable-next-line no-shadow
export const enum CruiseType {
  // eslint-disable-next-line no-unused-vars
  SEA = 'sea',
  // eslint-disable-next-line no-unused-vars
  RIVER = 'rivers',
}
